'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard', {
            url: '/dashboard',
            templateUrl: 'dashboard/dashboard.html',
            controller: 'dashboardCtrl as ctrl',
            parent: 'app',
            abstract: true,
            resolve: {
                departments: ['$http', 'Department', '$state', 'Authentication', 'myDepartments', function ($http, Department, $state, Authentication, myDepartments) {
                    // console.log('$state.current.name', $state.current)

                    let departments = myDepartments.get();
                    // console.log('llamado 4 myDepartments.get()', departments)
                    if(departments)
                        return departments;
                    
                    return myDepartments.load(Authentication.isAuthorized("viewer")).then(function (departments) {
                        if (!departments.length && !Authentication.isAuthorized('admin')) {
                            /* Authentication.logOut();
                            return $state.go('login'); */
                            $state.go('waiting');
                        }
                        return departments;
                    });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser']
            }
        });
};
